import React from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router'; // import the react-router-dom components
import RegisterActions from '../../redux/reducers/register_reducer/actions';
// import RegisterForm from './components/register_form';
import RegisterForm from '../../components/app_common/register_form';
import useStyles from './styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TranslatedText from '../../components/atoms/translated_text';
import Configuration, { Translations } from './configuration';

const RegisterPage = (props: any) => {
  // console.log('Render RegisterPage');
  const dispatch = useDispatch();
  const classes = useStyles();

  React.useEffect(() => {
    dispatch(RegisterActions.fetchSchemeTypesAction());
  }, [dispatch]);

  return (
    <Grid container component="main" className={classes.root}>
      <div className={classes.paper}>
        <img src={Configuration.registerIcon} className={classes.img_logo} />
        <Typography component="h1" variant="h5">
          <TranslatedText textMap={Translations.signup_title} />
        </Typography>
        <RegisterForm />
      </div>
    </Grid>
  );
};

export default withRouter(RegisterPage);
